if (!customElements.get('lookbook-slider')) {
  customElements.define(
    'lookbook-slider',
    class LookbookSlider extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.lookbook-slider__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };

        this.classes = {
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.paginationType = this.dataset.paginationType || 'bullets';
        this.enableSlider = this.dataset.enableSlider === 'true';
this.layoutMode = this.dataset.layoutMode || 'mode_default';
this.centerWidth = parseInt(this.dataset.centerWidth || '80', 10);
this.peekPercent = parseInt(this.dataset.peekPercent || '0', 10);
this.autoplay = this.dataset.autoplay === 'true';
this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed || '5', 10) * 1000;
this.showProgressBar = this.dataset.showProgressBar !== 'false';
this.coverflowMode = this.dataset.coverflow === 'true';


        this.sliderInstance = false;

        if (!this.enableSlider) return;
        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        // Destroy existing slider first when reinitializing (e.g. on resize)
        this.destroySlider();

        this.initSlider(FoxTheme.config.mqlMobile);
        this.calculateItemsWidth();
        this.applyPeekPercent();
      }

      initSlider(isMobile = false) {
        this.sliderOptions = {
          slidesPerView: 'auto',
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          loop: true,
          threshold: 2,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          watchSlidesProgress: true,
        };

// Autoplay
if (this.autoplay) {
  this.sliderOptions.autoplay = {
    delay: this.autoplaySpeed,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  };
}

// ==============================
// Layout mode overrides (addon)
// ==============================
const slidesCount = this.sliderWrapper ? this.sliderWrapper.children.length : 0;

// Mode1: infinite loop
if (this.layoutMode === 'mode_1_center_peek') {
  this.sliderOptions.centeredSlides = true;
  this.sliderOptions.centeredSlidesBounds = false;

  // allow infinite looping even with 3 slides
  this.sliderOptions.loop = slidesCount > 1;

  // improve loop stability with slidesPerView:'auto'
  this.sliderOptions.loopedSlides = slidesCount;
  this.sliderOptions.loopAdditionalSlides = slidesCount;

  // 3 slides -> start from middle
  if (slidesCount === 3) this.sliderOptions.initialSlide = 1;

  // Coverflow: no pagination dots; arrows handled manually (not via Swiper Navigation)
  if (this.coverflowMode) {
    this.sliderOptions.pagination = false;
    this.sliderOptions.navigation = false;
  }
}

// Mode2: left align + visible right peek area
if (this.layoutMode === 'mode_2_end_peek') {
  this.sliderOptions.centeredSlides = false;
  this.sliderOptions.centeredSlidesBounds = false;
  this.sliderOptions.loop = false;
}

// Mobile overrides: full-width one-at-a-time, no mousewheel
if (isMobile) {
  this.sliderOptions.slidesPerView = 1 + this.peekPercent / 100;
  this.sliderOptions.centeredSlides = false;
  this.sliderOptions.centeredSlidesBounds = false;
  this.sliderOptions.mousewheel = false;
  this.sliderOptions.loop = slidesCount > 1;
  this.sliderOptions.navigation = false;
  this.sliderOptions.spaceBetween = 0;
  if (!this.showProgressBar) {
    this.sliderOptions.pagination = false;
  }
}



        if (typeof this.sliderInstance !== 'object') {
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
          const swiperModules = [FoxTheme.Swiper.Mousewheel];
          if (this.autoplay && FoxTheme.Swiper.Autoplay) {
            swiperModules.push(FoxTheme.Swiper.Autoplay);
          }
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, swiperModules);
          this.sliderInstance.init();

          // Coverflow: bind arrow clicks manually (bypassing Swiper Navigation module)
          if (this.coverflowMode) {
            this.bindCoverflowNav();
          }
        }
        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.destroyCoverflowNav();
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      bindCoverflowNav() {
        const stage = this.closest('.lookbook-cf-stage');
        if (!stage) return;
        const prev = stage.querySelector('.lookbook-cf-arrow--prev');
        const next = stage.querySelector('.lookbook-cf-arrow--next');
        const slider = this.sliderInstance && this.sliderInstance.slider;
        if (!slider) return;
        this._cfPrevHandler = () => slider.slidePrev();
        this._cfNextHandler = () => slider.slideNext();
        if (prev) prev.addEventListener('click', this._cfPrevHandler);
        if (next) next.addEventListener('click', this._cfNextHandler);
        this._cfPrev = prev;
        this._cfNext = next;
      }

      destroyCoverflowNav() {
        if (this._cfPrev && this._cfPrevHandler) this._cfPrev.removeEventListener('click', this._cfPrevHandler);
        if (this._cfNext && this._cfNextHandler) this._cfNext.removeEventListener('click', this._cfNextHandler);
        this._cfPrev = null;
        this._cfNext = null;
        this._cfPrevHandler = null;
        this._cfNextHandler = null;
      }

calculateItemsWidth() {
  Array.from(this.sliderWrapper.children).forEach((item) => {
    const width = item.dataset.width;
    const widthMobile = item.dataset.widthMobile;

    // Mode 1 forces desktop width to centerWidth%
    if (this.layoutMode === 'mode_1_center_peek' && !FoxTheme.config.mqlMobile) {
      item.style.setProperty('--item-width', `${this.centerWidth}%`);
    } else {
      item.style.setProperty('--item-width', width);
    }

    item.style.setProperty('--item-width-mobile', widthMobile);
  });
}

applyPeekPercent() {
  if (!this.peekPercent || this.peekPercent <= 0) {
    this.style.removeProperty('--peek-offset');
    this.style.removeProperty('--mobile-peek-scale');
    return;
  }
  const scale = Math.round(100 / (100 + this.peekPercent) * 100) / 100;
  this.style.setProperty('--mobile-peek-scale', String(scale));
  requestAnimationFrame(() => {
    const firstSlide = this.sliderWrapper.children[0];
    if (firstSlide) {
      const peekPx = Math.round(firstSlide.offsetWidth * this.peekPercent / 100);
      this.style.setProperty('--peek-offset', peekPx + 'px');
    }
  });
}

    }
  );
}

if (!customElements.get('lookbook-scroll-progress-bar')) {
  customElements.define(
    'lookbook-scroll-progress-bar',
    class LookbookScrollProgressBar extends ScrollProgressBar {
      get totalWidth() {
        this.allChildren = this.target.children;

        let totalWidth = 0;
        [...this.allChildren].forEach((child) => {
          totalWidth += child.offsetWidth;
        });

        return totalWidth;
      }
    }
  );
}
